import { CommandBase } from "../../../../common/services/cqs/commandManager";

export class SetKundorderradLeveransradKvantitetCommand extends CommandBase {
    kundorderradId: number;
    overenskommenKvantitetLeveransrad: number;

    constructor(init: (instance: SetKundorderradLeveransradKvantitetCommand) => void) {
        super("SetKundorderradLeveransradKvantitetCommand");
        init(this);
    }
}
